import { jsxs as r, jsx as e, Fragment as f } from "react/jsx-runtime";
import { Box as i, Skeleton as b, FormLabel as s, Typography as d } from "@mui/material";
import x from "dayjs";
import "../../../queries/message/index.js";
import "../../../queries/contact/index.js";
import "../../../queries/calendars/index.js";
import { G as y } from "../../../index-DNTqwtVt.js";
import "../../../queries/student/index.js";
import "../../../queries/settings/index.js";
import "../../../queries/points/index.js";
import "../../../queries/assessment/index.js";
import "../../../queries/assessment/annotations/index.js";
import "../../../queries/assessment/rubrics/index.js";
import "../../../queries/assessment/qcesubjects/index.js";
import "../../../queries/assessment/extensionrequest/index.js";
import "../../../queries/files/index.js";
import { attendance as D } from "../../../queries/attendance/index.js";
import "../../../queries/forms/index.js";
import "../../../queries/notifications/index.js";
import "../../../queries/interviews/index.js";
import "../../../queries/notes/index.js";
import "../../../queries/annoucements/index.js";
import "../../../queries/payments/index.js";
import "../../../queries/assessment/analysis/index.js";
import "../../../queries/group/index.js";
import "../../../queries/projects/index.js";
import "../../../queries/courses/index.js";
import "../../../queries/password/index.js";
import { MessageType as S } from "../../../helpers/daymaptypes.js";
const X = ({ message: o }) => {
  const { data: p, isPending: u } = new D.absentReasons({ adminCodes: !1 }).ToQuery(), n = { display: "flex", gap: 1, alignItems: "center" };
  if (u)
    return /* @__PURE__ */ r(i, { ...n, children: [
      /* @__PURE__ */ e(b, { width: 50, sx: { fontSize: "1.5rem" } }),
      /* @__PURE__ */ e(b, { width: 50, sx: { fontSize: "1.5rem" } })
    ] });
  let l = null;
  if (o.MessageType === S.AbsenceInbound && o.Properties) {
    const { AbsenceDate: c, AbsenceReason: m, AbsentStudent: a } = o.Properties;
    let h = m;
    p != null && p.some((t) => t.Code === m) && (h = p.find((t) => t.Code === m).Description), l = /* @__PURE__ */ r(f, { children: [
      c && /* @__PURE__ */ r(i, { ...n, children: [
        /* @__PURE__ */ e(s, { children: "Absence Date:" }),
        /* @__PURE__ */ e(d, { children: x(c, "YYYY-MM-DD").toDate().toDateString() })
      ] }),
      m && /* @__PURE__ */ r(i, { ...n, children: [
        /* @__PURE__ */ e(s, { children: "Reason Code:" }),
        /* @__PURE__ */ e(d, { children: h })
      ] }),
      a && /* @__PURE__ */ r(i, { ...n, children: [
        /* @__PURE__ */ e(s, { children: "Student:" }),
        a.split(",").map((t) => /* @__PURE__ */ e(y, { studentId: Number(t) }, t))
      ] })
    ] });
  }
  return /* @__PURE__ */ r(i, { display: "flex", gap: 3, flexWrap: "wrap", children: [
    o.SentTo && /* @__PURE__ */ e(f, { children: /* @__PURE__ */ r(i, { ...n, children: [
      /* @__PURE__ */ e(s, { children: "To:" }),
      /* @__PURE__ */ e(d, { children: o.SentTo })
    ] }) }),
    l
  ] });
};
export {
  X as MessageDetails
};
//# sourceMappingURL=MessageDetails.js.map
